import { testimonials } from "@/mocks/updiag";
import { SHOW_REVIEWS } from "@/config/features";

export default function TestimonialsSection() {
  if (!SHOW_REVIEWS) return null;
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-yellow-50 text-[#F59E0B] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Avis clients
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Ils nous font confiance
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#F59E0B] text-xl"></i>)}
            <span className="text-2xl font-extrabold text-[#0F3B5F] ml-2" style={{ fontFamily: "Barlow, sans-serif" }}>4.9/5</span>
          </div>
          <p className="text-gray-400 text-sm">Basé sur 127 avis Google vérifiés</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-[#F8FAFC] rounded-2xl p-7 border-l-4 border-[#F97316] hover:-translate-y-1 transition-all duration-300">
              <div className="flex gap-0.5 mb-4">
                {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#F59E0B]"></i>)}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed italic mb-6">"{t.text}"</p>
              <div className="border-t border-gray-200 pt-4 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover object-top" loading="lazy" />
                <div>
                  <div className="font-bold text-[#0F3B5F] text-sm">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.type} — {t.location}</div>
                </div>
                <div className="ml-auto flex items-center gap-1 text-xs text-gray-400">
                  <i className="ri-google-fill text-[#F97316]"></i>
                  Vérifié
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
